import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import articleStyles from '@shared/components/article/style.module.scss'
import { getImgURL, getDesignation, getYearFromTimestamp } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
// import { PencilIcon } from '../../ctIcons'

import noImage from '@assets/images/placeholder/person-placeholder.png'
import useWindowSize from '@shared/hooks/windowSize'

const MyImage = dynamic(() => import('@shared/components/myImage'))

function AuthorDetailCard({ data }) {
  const [width] = useWindowSize()
  return (
    <>
      <div className={`${articleStyles.article} my-3 d-flex align-items-center gap-3`}>
        <div className={`${articleStyles.postimg} ${styles.postimg} rounded-circle d-block block-img flex-shrink-0`}>
          <MyImage
            src={getImgURL(data?.sUrl) || noImage}
            alt={`Author ${data?.sFName}`}
            placeholder="blur"
            blurDataURL={BLUR_DATA_URL_BASE64}
            layout="fill"
          />
        </div>
        <div className="flex-grow-1 d-flex">
          <div className="flex-grow-1 me-3">
            <h3 className="big-text mb-0">
              {data?.sFName}
              {data?.bIsVerified && (
                <span className={`${styles.verfied} d-inline-block rounded-circle align-text-top`} />
              )}
            </h3>
            <div>
              <p className="mb-1 mt-2">{`${'Active Since'} ${getYearFromTimestamp(data?.dCreated)}`}</p>
            </div>
            <div className="text-muted">
              <span className="xsmall-text mb-2 d-block">{getDesignation(data.eDesignation)}</span>
              {/* <div className="text-capitalize">
                <PencilIcon width="20" height="20" className="flex-shrink-0 me-1" /> {data?.nArticleCount} {"posts"}
              </div> */}
              {
                data?.sBio && width > 992 && (
                  <p className="mb-0">{data?.sBio}</p>
                )
              }
            </div>
          </div>
          {/* <div className="flex-shrink-0 d-flex flex-column align-items-center text-muted">
            <EyeIcon width="45" height="45" />
            <h5 className="mb-0 fw-normal">{abbreviateNumber(data?.nViewCount || 0)}</h5>
            <span className="text-uppercase">{"views"}</span>
          </div> */}
        </div>
      </div>
      {
        width < 993 && (
          <p className="mb-0 text-muted">{data?.sBio}</p>
        )
      }
    </>
  )
}

AuthorDetailCard.propTypes = {
  data: PropTypes.object
}

AuthorDetailCard.defaultProps = {
  data: {}
}

export default AuthorDetailCard
